module.exports = __webpack_public_path__ + "static/media/PHOTO-2020-07-22-21-13-35.179db5b4.jpg";